import React from 'react'
import './Messages.css'

export interface MessagesProps {
	messages: Message[]
}

export interface Message {
	text: string
	type: 'error' | 'info' | 'success' | 'warning'
}

export function Messages(props: MessagesProps): JSX.Element | null {

	const [fading, setFading] = React.useState(false)
	const [shown, setShown] = React.useState(false)

	React.useEffect(() => {
		let timeout: NodeJS.Timeout
		if (props.messages.length > 0) {
			setShown(true)
			setFading(false)
			timeout = setTimeout(() => {
				setFading(true)
			}, 6000)
		}

		return () => {
			if (timeout) {
				clearTimeout(timeout)
			}
		}
	}, [props.messages.length])

	if (!shown) {
		return null
	}

	return (
		<div id='messages' className={`${fading ? 'fading' : null}`} onTransitionEnd={() => { setShown(false) }}>
			{
				props.messages.map((message, i) =>
					<div key={i} className={message.type}>
						{message.text}
					</div>
				)
			}
		</div>
	)
}
